<template>
  <div class="order-form-wrapper">
    <!-- Заголовок как в OrderEdit -->
    <div class="order-head cleared">
      <div class="order-head__flex ft-lt cleared">
        <div class="left_head">
          <div class="order-num ft-lt">
            📊 <span v-if="activeTab === 'rating'">Рейтинг менеджеров</span>
            <span v-else>Статистика звонков</span>
          </div>
          <div class="s-and-a ft-lt">
            <div class="order-sum">
              <div class="s-and-a__discr gray italic">За период</div>
              <div class="value">
                <template v-if="activeTab === 'rating'">
                  <input type="date" v-model="dateFrom" class="date-input" style="width: 140px;" />
                  <span style="margin: 0 8px;">—</span>
                  <input type="date" v-model="dateTo" class="date-input" style="width: 140px;" />
                  <button @click="fetchManagers" class="btn btn-primary small" style="margin-left: 12px;">Показать</button>
                </template>
                <template v-else>
                  {{ callStatsDate }}
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="right_head">
          <div class="tabs">
            <button :class="{active: activeTab === 'rating'}" @click="activeTab = 'rating'">Рейтинг</button>
            <button :class="{active: activeTab === 'calls'}" @click="activeTab = 'calls'; fetchUnsuccessfulCalls()">Статистика звонков</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Контент рейтинга -->
    <div v-if="activeTab === 'rating'" class="m-box">
      <div class="inside">
        <table class="modern-table">
      <thead>
        <tr>
              <th @click="setSort('label')" class="sortable">Менеджер</th>
              <th @click="setSort('bonus')" class="sortable">💰 Бонус</th>
              <th @click="setSort('totalOrders')" class="sortable">📦 Заказов всего</th>
              <th @click="setSort('successfulOrders')" class="sortable">✅ Успешных</th>
              <th @click="setSort('canceledOrders')" class="sortable">❌ Отменено</th>
              <th @click="setSort('averageBonus')" class="sortable">📈 Средний бонус</th>
              <th @click="setSort('conversion')" class="sortable">📊 Конверсия (%)</th>
              <th @click="setSort('efficiency')" class="sortable">✨ Эффективность</th>
        </tr>
      </thead>
      <tbody>
            <tr v-for="manager in sortedManagers" :key="manager.customFieldValue" class="manager-row" @click="manager.customFieldValue ? $router.push({ name: 'ManagerRatingDetails', params: { managerId: manager.customFieldValue } }) : null" :style="manager.customFieldValue ? 'cursor:pointer' : 'cursor:default'">
              <td class="manager-name">
                <span v-if="sortedManagers.indexOf(manager) === 0" class="medal gold">🥇</span>
                <span v-else-if="sortedManagers.indexOf(manager) === 1" class="medal silver">🥈</span>
                <span v-else-if="sortedManagers.indexOf(manager) === 2" class="medal bronze">🥉</span>
  {{ manager.label }}
</td>
              <td class="number-cell blur-bonus">{{ manager.bonus.toFixed(2) }}</td>
              <td class="number-cell">{{ manager.totalOrders }}</td>
              <td class="number-cell">{{ manager.successfulOrders || 0 }}</td>
              <td class="number-cell">{{ manager.canceledOrders || 0 }}</td>
              <td class="number-cell">
            {{
              manager.successfulOrders > 0
                ? (manager.bonus / manager.successfulOrders).toFixed(2)
                : '0.00'
            }}
          </td>
              <td class="number-cell">{{ manager.conversion.toFixed(1) }}%</td>
              <td class="number-cell efficiency">{{ manager.efficiency.toFixed(1) }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr style="font-weight: bold; background: #f3f6fa;">
          <td>Итого</td>
          <td class="number-cell blur-bonus">{{ totalBonus.toFixed(2) }}</td>
          <td class="number-cell">{{ totalOrders }}</td>
          <td class="number-cell">{{ totalSuccessfulOrders }}</td>
          <td class="number-cell">{{ totalCanceledOrders }}</td>
          <td class="number-cell">{{ avgBonus.toFixed(2) }}</td>
          <td class="number-cell">{{ avgConversion.toFixed(1) }}%</td>
          <td class="number-cell efficiency">{{ avgEfficiency.toFixed(1) }}</td>
        </tr>
      </tfoot>
    </table>

        <!-- Графики -->
        <div class="charts-section">
          <div class="chart-container">
            <h3>Бонусы</h3>
    <canvas id="bonusChart"></canvas>
          </div>
          <div class="chart-container">
            <h3>Заказы</h3>
    <canvas id="ordersChart"></canvas>
          </div>
          <div class="chart-container">
            <h3>Отмены</h3>
    <canvas id="canceledChart"></canvas>
          </div>
          <div class="chart-container">
            <h3>Эффективность</h3>
<canvas id="efficiencyChart"></canvas>
          </div>
        </div>
      </div>
    </div>

    <!-- Контент статистики звонков -->
    <div v-else-if="activeTab === 'calls'" class="m-box">
      <div class="inside">
        <!-- Фильтр по дате -->
        <div class="date-filter">
          <div class="s-and-a">
            <div class="s-and-a__discr gray italic">Выберите дату</div>
            <input type="date" v-model="callStatsDate" @change="fetchCallStats" class="date-input" />
            <button @click="fetchCallStats" class="btn btn-primary small">Обновить</button>
  </div>
        </div>
        
        <!-- Общая статистика за день в виде таблицы -->
        <div class="stats-section">
          <div class="section-header">
            <h3 class="section-title">📊 Общая статистика за день</h3>
            <button v-if="selectedManagerId" @click="clearManagerSelection" class="btn btn-secondary small">
              ← Вернуться к общей статистике
            </button>
          </div>
          
          <div v-if="dailyCallStats.length" class="table-wrapper">
            <table class="modern-table stats-table">
              <thead>
                <tr>
                  <th @click="sortCallStats('managerName')" class="sortable">Менеджер</th>
                  <th @click="sortCallStats('totalCalls')" class="sortable">📞 Всего звонков</th>
                  <th @click="sortCallStats('totalIncoming')" class="sortable">📥 Входящие</th>
                  <th @click="sortCallStats('totalOutgoing')" class="sortable">📤 Исходящие</th>
                  <th @click="sortCallStats('newCallsAnswered')" class="sortable">🆕 Принято новых</th>
                  <th @click="sortCallStats('totalOrdersByCalls')" class="sortable">📦 Заказов по звонкам</th>
                  <th @click="sortCallStats('successfulOrdersByCalls')" class="sortable">✅ Успешных заказов</th>
                  <th @click="sortCallStats('canceledOrdersByCalls')" class="sortable">❌ Отменённых заказов</th>
                  <th @click="sortCallStats('conversionRate')" class="sortable">📊 Конверсия (%)</th>
                  <th @click="sortCallStats('totalDuration')" class="sortable">⏱️ Время разговора</th>
                  <th @click="sortCallStats('avgCallDuration')" class="sortable">📊 Среднее время</th>
                  <th @click="sortCallStats('callsPerHour')" class="sortable">⚡ Звонков/час</th>
                  <th @click="sortCallStats('efficiency')" class="sortable">✨ Эффективность</th>
                </tr>
              </thead>
              <tbody>
                <tr 
                  v-for="(stats, index) in sortedCallStats" 
                  :key="stats.managerId"
                  class="manager-row clickable"
                  @click="selectManager(stats.managerId)"
                  :class="{ 
                    active: selectedManagerId === stats.managerId,
                    'top-performer': index < 3 
                  }"
                >
                  <td class="manager-name">
                    <span v-if="index === 0" class="medal gold">🥇</span>
                    <span v-else-if="index === 1" class="medal silver">🥈</span>
                    <span v-else-if="index === 2" class="medal bronze">🥉</span>
                    {{ getManagerLabel(stats.managerId) }}
                  </td>
                  <td class="number-cell">{{ stats.totalCalls }}</td>
                  <td class="number-cell incoming">{{ stats.totalIncoming }}</td>
                  <td class="number-cell outgoing">{{ stats.totalOutgoing }}</td>
                  <td class="number-cell answered">{{ stats.newCallsAnswered || 0 }}</td>
                  <td class="number-cell">{{ stats.totalOrdersByCalls }}</td>
                  <td class="number-cell effective">{{ stats.successfulOrdersByCalls }}</td>
                  <td class="number-cell canceled">{{ stats.canceledOrdersByCalls }}</td>
                  <td class="number-cell conversion">{{ stats.conversionRate }}%</td>
                  <td class="number-cell time">{{ formatDuration(stats.totalDuration) }}</td>
                  <td class="number-cell">{{ formatDuration(stats.avgCallDuration) }}</td>
                  <td class="number-cell">{{ stats.callsPerHour.toFixed(1) }}</td>
                  <td class="number-cell efficiency">{{ stats.efficiency.toFixed(1) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="no-data">
            <p>📭 Нет данных за выбранный день</p>
          </div>
        </div>

        <!-- Дополнительная аналитика -->
        <div v-if="dailyCallStats.length" class="analytics-section">
          <h3 class="section-title">📈 Дополнительная аналитика</h3>
          <div class="analytics-grid">
            <div class="analytics-card">
              <div class="analytics-card-header">
                <h4>🎯 Топ по эффективности</h4>
              </div>
              <div class="analytics-card-content">
                <div v-for="(manager, index) in topPerformers" :key="manager.managerId" class="top-item">
                  <span class="rank">{{ index + 1 }}.</span>
                  <span class="name">{{ getManagerLabel(manager.managerId) }}</span>
                  <span class="value">{{ manager.efficiency.toFixed(1) }}</span>
                </div>
              </div>
            </div>
            
            <div class="analytics-card">
              <div class="analytics-card-header">
                <h4>📞 Активность звонков</h4>
              </div>
              <div class="analytics-card-content">
                <div class="metric-item">
                  <span class="metric-label">Всего звонков:</span>
                  <span class="metric-value">{{ totalCallsToday }}</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">Входящих всего:</span>
                  <span class="metric-value">{{ totalIncomingCallsToday }}</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">Среднее время:</span>
                  <span class="metric-value">{{ formatDuration(avgCallDurationToday) }}</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">Принято новых:</span>
                  <span class="metric-value">{{ totalNewCallsAnswered }}</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">Эффективные звонки:</span>
                  <span class="metric-value">{{ totalEffectiveCallsToday }}</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">Общая конверсия:</span>
                  <span class="metric-value">{{ overallConversionToday }}%</span>
                </div>
              </div>
            </div>

            <div class="analytics-card">
              <div class="analytics-card-header">
                <h4>⏰ Время работы</h4>
              </div>
              <div class="analytics-card-content">
                <div class="metric-item">
                  <span class="metric-label">Общее время:</span>
                  <span class="metric-value">{{ formatDuration(totalTalkTimeToday) }}</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">Самый долгий:</span>
                  <span class="metric-value">{{ longestCallManager }}</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">Самый активный:</span>
                  <span class="metric-value">{{ mostActiveManager }}</span>
                </div>
              </div>
            </div>

            <div class="analytics-card">
              <div class="analytics-card-header">
                <h4>📊 Соотношения</h4>
              </div>
              <div class="analytics-card-content">
                <div class="metric-item">
                  <span class="metric-label">Входящие/Исходящие:</span>
                  <span class="metric-value">{{ incomingOutgoingRatio }}</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">Конверсия приема:</span>
                  <span class="metric-value">{{ newCallsConversion }}%</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">Активных менеджеров:</span>
                  <span class="metric-value">{{ activeManagersCount }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Детальная статистика по часам -->
        <div v-if="selectedManagerId && selectedManagerCallStats.length" class="details-section">
          <h3 class="section-title">🕐 Детальная статистика по часам - {{ getManagerLabel(selectedManagerId) }}</h3>
          <table class="modern-table details-table">
            <thead>
              <tr>
                <th>Час</th>
                <th>Всего звонков</th>
                <th>Входящие</th>
                <th>Исходящие</th>
                <th>Общее время</th>
                <th>Время входящих</th>
                <th>Время исходящих</th>
                <th>Среднее время</th>
                <th>Новых принято</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in selectedManagerCallStats" :key="row.hour" class="hour-row">
                <td class="hour-cell">{{ row.hour }}:00</td>
                <td class="number-cell">{{ row.callCount }}</td>
                <td class="number-cell incoming">{{ row.incomingCallCount }}</td>
                <td class="number-cell outgoing">{{ row.outgoingCallCount }}</td>
                <td class="number-cell time">{{ formatDuration(row.totalDuration || 0) }}</td>
                <td class="number-cell time">{{ formatDuration(row.incomingDuration || 0) }}</td>
                <td class="number-cell time">{{ formatDuration(row.outgoingDuration || 0) }}</td>
                <td class="number-cell">{{ row.callCount > 0 ? formatDuration(Math.round(row.totalDuration / row.callCount)) : '0с' }}</td>
                <td class="number-cell answered">{{ row.newCallsAnswered || 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- График звонков -->
        <div v-if="callStats.length" class="chart-container">
          <h3>📈 График активности звонков</h3>
          <canvas id="callsChart"></canvas>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { ORDERS_API_BASE } from '@/config/api';
import axios from 'axios';
import Chart from 'chart.js/dist/Chart.js';

export default {
  name: 'ManagerRating',
  data() {
    const todayStr = new Date().toISOString().slice(0, 10);
    return {
      today: todayStr,
      callStatsDate: todayStr,
      dateFrom: todayStr,
      dateTo: todayStr,
      managers: [],
      /** Записи из /users-settings — фильтр рейтинга по active и hideInStats */
      usersSettings: [],
      sortKey: 'bonus',
      sortDesc: true,
      bonusOrdersCount: 0,
      cancellationStatuses: [
        'kontrol-vozvratr-magazin', 'kfhdlfhgkfldfofuglfdlidfhgfdgjlfklghldfk', '7kontrol-otmena', '876h-hk-kjhkj', '15k-usljsd-sl', 'cancel-other',
        'delyvery-did-not-suit', 'otmenasdoskdfjdkfj', 'otmenasdostavk', 'otmena-s-otgruzkoi-kureru', 'otmena-sotgruz-kupil', 'otmena-vozim-by', 'send-to-assembling', 'otmena-nashel-konkurentov',
        'kdjfffffff8hjf', 'klkhdshjlsd88sdfsdf898', 'kiuhhjsdsdkkkkkkk12', 'pod-zakaz', 'dffddsdfsdd'
      ],
      successfulStatuses: [
        'assembling', 'assembling-complete', '4-komplektuetsya-sklad-sharangovicha-kurer-2',
        '3-komplektuetsya-sklad-sharangovicha-kurer-1', 'ktuetsya-sklad-sharangovicha-kur234234ggg',
        'jdhfjfhjdhfjdhfdfhhhhhhhhhhhhh', '8-komplektuetsia-sklad-karvata-kurer-8',
        '7-komplektuetsia-sklad-karvata-kurer-7', '10-komplektuetsia-sklad-karvata-kurer-10',
        '9-komplektuetsia-sklad-karvata-kurer-9', 'send-to-delivery', 'redirect', 'fdjkdfkljd',
        'dskjdslksd', 'zakaz-dostavlen-kur', '1-zakaz-kurerom-dostavlen-dengi-i-bu-sdany',
        'fdkjsdkjdsklkl1', 'korrektirovka-zakaza', 'dsfssffsds', 'kushddflsidudhy', 'offer-analog', 
        'nelvvhs47ujgt', 'kontrolhgcfxhg', 'kontrol-vozvrat-na-sklad', '12kontrol-obmen'
      ],
      excludedBonusStatuses: [
        
        'cancel-other', 'otmena-s-otgruzkoi-kureru', 'otmena-vozim-by',
        'povregden-tovar-piidostavke', 'delyvery-did-not-suit', 'otmenasdostavk',
        'prodaza-chastichnaya-sostoyalas', 'otmena-dubl', 'obmen-s-doplatiu',
        'kiuhhjsdsdkkkkkkk12', 'otmenaskomentom', 'klkhdshjlsd88sdfsdf898',
        'kdjfffffff8hjf', 'khkhhjgsdlgtij6', 'send-to-assembling',
        'otmenasdoskdfjdkfj', 'otmena-kupil-u-dr-mened', 'otmena-sotgruz-kupil',
        'otmena-nashel-konkurentov', 'otmenasvozvratomvmagazin', '5blsdfhoisdhflkdshf',
        'otmena-magas-mesto-man', 'otmena-s-necelevoi', 'kldjfdfdfsdfsdfdfffffffffffffff',
        
        'new', 'availability-confirmed', 'sdilsddkls', 'lskdjslkklsk', 'dffddsdfsdd',
        'offer-analog', 'maslosto', 'vzial-v-rabotu', 'sdlkfsdjfsdfsdf-sdfgsdf-sdf',
        'pod-zakaz', 'novyi-beznalnyi-klient',
        '1-priniat-na-proverku-sostavleny-vse-bumagi-postavil-na-zariadku',
        '2a-akb-zariadilsia-klienta-uvedomil-zhdu-ego-vizita',
        '2b-ne-zariadilsia-klienta-uvedomil-zhdu-ego-vizita-sniat-s-garantii',
        '3-1-s-karvata-peredali-na-mashinostroitelei-servis',
        '3-1-s-karvata-peredali-postavshchiku-importioru-ne-nasha-akb',
        '3-2-s-mashinostroitelei-servis-peredali-na-karvata',
        '4-otkaz-net-braka-budet-vozvrat-klientu',
        '0-vopros-uregulirovan-klient-bolshe-ne-bespokoit',
        '0-neobkhodim-otvet-na-pretenziiu', '0-otvet-otpravlen-potrebiteliu',
        '6-postavshchik-vernul-nam-novyi-akb-vmesto-braka',
        '3-2-ot-postavshchika-peredali-na-karvata',
        '4-brak-podtverzhdion-soglasovyvaetsia-zamena-klienta-opovestil',
        '2g-ne-zariadilsia-klienta-uvedomil-chto-peredaiu-na-minsk-vozmozhno-brak',
        '5-vydan-pokupateliu-novyi-akb-dokumenty-podписаны-вопрос-закрыт',
        '5-vydan-obratno-ego-zhe-akb-ne-zariadilsia-сниат-с-гарантии',
        'ili-dengi-dokumenty-podpisany',
        '2-vopros-uregulirovan-v-magazine-vozvrashchion-klientu-zariazhennym',
        'sto-prodazaza', 'stoffnksajn12212', 'avto-v-remonte-v-tsekhu', 'stowfifdk2j',
        'gotov-k-vydache', 'prokonsultirovan-perezvonit-pozzhe',
        'neobkhodimo-perezvonit-klientu-zapchasti-tseny-perechen-rabot-sto',
        '5-avto-vydan-klientu'
      ],
      activeTab: 'rating',
      callStats: [],
      dailyCallStats: [], // Для общей статистики за день
      callsChart: null,
      selectedManagerId: null, // Выбранный менеджер для детальной статистики
      selectedManagerCallStats: [], // Детальная статистика выбранного менеджера
      callStatsSortKey: 'efficiency',
      callStatsSortDesc: true
    };
  },
  computed: {
    sortedManagers() {
      const withCalculatedFields = this.managers.map(m => {
        // Считаем только по успешным и отменённым заказам
        const base = m.successfulOrders + m.canceledOrders;
        const averageBonus = m.successfulOrders > 0 ? m.bonus / m.successfulOrders : 0;
        const conversion = base > 0 ? (m.successfulOrders / base) * 100 : 0;
        const efficiency = (conversion * 0.3) + (averageBonus * 0.2);

        return {
          ...m,
          averageBonus,
          conversion,
          efficiency
        };
      });

      // Показываем всех менеджеров (убираем фильтр по количеству заказов)
      return withCalculatedFields.sort((a, b) => {
        const modifier = this.sortDesc ? -1 : 1;
        if (a[this.sortKey] < b[this.sortKey]) return -1 * modifier;
        if (a[this.sortKey] > b[this.sortKey]) return 1 * modifier;
        return 0;
      });
    },
    
    sortedCallStats() {
      const withCalculatedFields = this.dailyCallStats.map(stats => {
        const avgCallDuration = stats.totalCalls > 0 ? Math.round(stats.totalDuration / stats.totalCalls) : 0;
        const callsPerHour = stats.totalCalls / 8; // Предполагаем 8-часовой рабочий день
        const conversionRate = stats.totalCalls > 0 ? ((stats.effectiveCalls || 0) / stats.totalCalls * 100) : 0;
        const efficiency = (stats.totalCalls * 0.2) + (stats.totalDuration / 3600 * 0.2) + ((stats.newCallsAnswered || 0) * 0.3) + (conversionRate * 0.3);
        
        return {
          ...stats,
          avgCallDuration,
          callsPerHour,
          conversionRate,
          efficiency,
          managerName: this.getManagerLabel(stats.managerId)
        };
      });

      return withCalculatedFields.sort((a, b) => {
        const modifier = this.callStatsSortDesc ? -1 : 1;
        let aVal = a[this.callStatsSortKey];
        let bVal = b[this.callStatsSortKey];
        
        // Для строковых значений
        if (typeof aVal === 'string') {
          return aVal.localeCompare(bVal) * modifier;
        }
        
        if (aVal < bVal) return -1 * modifier;
        if (aVal > bVal) return 1 * modifier;
        return 0;
      });
    },

    // Дополнительная аналитика
    topPerformers() {
      return this.sortedCallStats.slice(0, 5);
    },

    totalBonus() {
      return this.managers.reduce((sum, m) => sum + m.bonus, 0);
    },
    totalOrders() {
      return this.managers.reduce((sum, m) => sum + m.totalOrders, 0);
    },
    totalSuccessfulOrders() {
      return this.managers.reduce((sum, m) => sum + (m.successfulOrders || 0), 0);
    },
    totalCanceledOrders() {
      return this.managers.reduce((sum, m) => sum + (m.canceledOrders || 0), 0);
    },
    avgBonus() {
      const filtered = this.managers.filter(m => m.successfulOrders >= 1);
      const totalSuccessful = filtered.reduce((sum, m) => sum + m.successfulOrders, 0);
      const totalBonus = filtered.reduce((sum, m) => sum + m.bonus, 0);
      return totalSuccessful > 0 ? totalBonus / totalSuccessful : 0;
    },
    avgConversion() {
      const totalSuccess = this.totalSuccessfulOrders;
      const totalCancel = this.totalCanceledOrders;
      const base = totalSuccess + totalCancel;
      return base > 0 ? (totalSuccess / base) * 100 : 0;
    },
    avgEfficiency() {
      const filtered = this.managers.filter(m => (m.successfulOrders + m.canceledOrders) >= 1);
      return filtered.length > 0 ? filtered.reduce((sum, m) => sum + m.efficiency, 0) / filtered.length : 0;
    },

    totalCallsToday() {
      return this.dailyCallStats.reduce((sum, stats) => sum + stats.totalCalls, 0);
    },

    totalIncomingCallsToday() {
      return this.dailyCallStats.reduce((sum, stats) => sum + stats.totalIncoming, 0);
    },

    avgCallDurationToday() {
      const totalDuration = this.dailyCallStats.reduce((sum, stats) => sum + stats.totalDuration, 0);
      return this.totalCallsToday > 0 ? Math.round(totalDuration / this.totalCallsToday) : 0;
    },

    totalNewCallsAnswered() {
      return this.dailyCallStats.reduce((sum, stats) => sum + (stats.newCallsAnswered || 0), 0);
    },

    totalEffectiveCallsToday() {
      return this.dailyCallStats.reduce((sum, stats) => sum + (stats.effectiveCalls || 0), 0);
    },

    overallConversionToday() {
      return this.totalCallsToday > 0 ? ((this.totalEffectiveCallsToday / this.totalCallsToday) * 100).toFixed(1) : 0;
    },

    totalTalkTimeToday() {
      return this.dailyCallStats.reduce((sum, stats) => sum + stats.totalDuration, 0);
    },

    longestCallManager() {
      if (!this.dailyCallStats.length) return 'Нет данных';
      const longest = this.dailyCallStats.reduce((max, stats) => 
        stats.totalDuration > max.totalDuration ? stats : max
      );
      return this.getManagerLabel(longest.managerId);
    },

    mostActiveManager() {
      if (!this.dailyCallStats.length) return 'Нет данных';
      const mostActive = this.dailyCallStats.reduce((max, stats) => 
        stats.totalCalls > max.totalCalls ? stats : max
      );
      return this.getManagerLabel(mostActive.managerId);
    },

    incomingOutgoingRatio() {
      const totalIncoming = this.dailyCallStats.reduce((sum, stats) => sum + stats.totalIncoming, 0);
      const totalOutgoing = this.dailyCallStats.reduce((sum, stats) => sum + stats.totalOutgoing, 0);
      if (totalOutgoing === 0) return 'Только входящие';
      return `${(totalIncoming / totalOutgoing).toFixed(1)}:1`;
    },

    newCallsConversion() {
      const totalIncoming = this.dailyCallStats.reduce((sum, stats) => sum + stats.totalIncoming, 0);
      const totalAnswered = this.totalNewCallsAnswered;
      return totalIncoming > 0 ? ((totalAnswered / totalIncoming) * 100).toFixed(1) : 0;
    },

    activeManagersCount() {
      return this.dailyCallStats.filter(stats => stats.totalCalls > 0).length;
    }
  },
  methods: {
    setSort(key) {
      if (this.sortKey === key) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortKey = key;
        this.sortDesc = true;
      }
    },

    async fetchUnsuccessfulCalls() {
    // Получаем вчерашнюю дату в формате YYYY-MM-DD
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const dateStr = yesterday.toISOString().slice(0, 10);

    // Сюда впишешь свой API-ключ
    const apiKey = 'vchi_9f42b55f8ad44b9ea1b910d452f43e9a22907f8e'; 

    try {
      const response = await axios.get('https://bot.vochi.by/api/v1/unsuccessful-calls', {
        params: {
          key: apiKey,
          date_from: dateStr,
          date_to: dateStr,
          direction: 'all', // Включаем и входящие, и исходящие
          limit: 100,       // Укажи нужный лимит
          offset: 0
        }
      });
      
      console.log('📊 Неуспешные звонки за вчера:', response.data);
    } catch (error) {
      console.error('❌ Ошибка при запросе неуспешных звонков:', error);
    }
  },

    truthyHideInStats(u) {
      return u.hideInStats === 1 || u.hideInStats === true || u.hideInStats === '1';
    },
    isUserActive(u) {
      return u.active === 1 || u.active === true || u.active === '1';
    },
    findUserBySymbolicCode(code) {
      if (code == null || code === '') return null;
      const c = String(code).trim().toLowerCase();
      for (let i = 0; i < this.usersSettings.length; i++) {
        const u = this.usersSettings[i];
        if (u.symbolicCode != null && String(u.symbolicCode).trim().toLowerCase() === c) return u;
      }
      return null;
    },
    /** Справочник managers (code) + users_settings */
    shouldShowManagerInRating(code) {
      const u = this.findUserBySymbolicCode(code);
      if (!u) return true;
      return this.isUserActive(u) && !this.truthyHideInStats(u);
    },
    /** Строки call-stats: manager_id = id из users_settings */
    isCallStatsRowHidden(managerId) {
      const mid = parseInt(managerId, 10);
      if (Number.isNaN(mid)) return false;
      const u = this.usersSettings.find(x => parseInt(x.id, 10) === mid);
      if (!u) return false;
      if (!this.isUserActive(u)) return true;
      return this.truthyHideInStats(u);
    },

    async fetchManagers() {
      try {
        let users = [];
        try {
          const usersRes = await axios.get('https://manager.1akb.by/users-settings');
          users = Array.isArray(usersRes.data) ? usersRes.data : [];
        } catch (eUs) {
          console.warn('Не удалось загрузить users-settings для фильтра рейтинга:', eUs);
        }
        this.usersSettings = users;

        const newManagersRes = await axios.get(ORDERS_API_BASE + '/managers.php');
        this.managers = [];

        if (Array.isArray(newManagersRes.data)) {
          newManagersRes.data.forEach(m => {
            if (!this.shouldShowManagerInRating(m.value)) return;
            this.managers.push({
              label: m.label,
              customFieldValue: m.value,
              bonus: 0,
              totalOrders: 0,
              sold: 0,
              bonusOrdersCount: 0,
              successfulOrders: 0,
              canceledOrders: 0
            });
          });
        }
        
        await this.fetchOrders();
        this.$nextTick(() => this.renderChart());
      } catch (e) {
        console.error('Ошибка при загрузке менеджеров:', e);
      }
    },

    async fetchOrders() {
      const baseParams = {
        per_page: 100
      };
      // Добавляем фильтр по дате
      if (this.dateFrom) baseParams['filter[createdAt][gte]'] = this.dateFrom;
      if (this.dateTo) baseParams['filter[createdAt][lte]'] = this.dateTo;
      
      const allCustomFieldValues = this.managers
        .map(m => m.customFieldValue)
        .filter(val => val !== null && val !== undefined && String(val).trim() !== '');

      if (allCustomFieldValues.length > 0) {
        baseParams['filter[managers][in][]'] = allCustomFieldValues;
      }
      
      // НЕ добавляем фильтр по статусам!

      let currentPage = 1;
      let totalPages = 1; 
      const allOrders = [];

      try {
        while (currentPage <= totalPages) {
          const params = { ...baseParams, page: currentPage };

          const res = await axios.get(ORDERS_API_BASE + '/orders.php', { params });

          if (res.data && Array.isArray(res.data.orders)) {
            allOrders.push(...res.data.orders);
          }

          if (res.data.pagination) {
            totalPages = res.data.pagination.totalPageCount || 1;
          }

          currentPage++;
        }

        // Группируем заказы по менеджерам с учетом приоритета кастомного поля managers
        const ordersByManager = {};
        
        // Показываем несколько примеров заказов для отладки
        console.log('Примеры заказов (первые 3):', allOrders.slice(0, 3).map(o => ({
          id: o.id,
          number: o.number,
          managerId: o.managerId,
          customFieldManager: o.customFields && o.customFields.manager ? o.customFields.manager : null
        })));
        
        allOrders.forEach(order => {
          const managerKey =
            order.customFields && order.customFields.manager
              ? order.customFields.manager
              : null;
          if (managerKey) {
            if (!ordersByManager[managerKey]) ordersByManager[managerKey] = [];
            ordersByManager[managerKey].push(order);
          }
        });
        
        console.log('Загружено заказов:', allOrders.length);
        console.log('Группировка заказов по менеджерам:', Object.keys(ordersByManager).map(key => ({
          key,
          count: ordersByManager[key].length
        })));

        this.managers.forEach(manager => {
          const managerKey = manager.customFieldValue;
          if (!managerKey) {
            console.warn('Менеджер без customFieldValue:', manager);
            return;
          }

          const orders = ordersByManager[managerKey] || [];
          
          manager.totalOrders = orders.length;
          manager.successfulOrders = orders.filter(o => this.successfulStatuses.includes(o.status)).length;
          manager.canceledOrders = orders.filter(o => this.cancellationStatuses.includes(o.status)).length;
          // Бонусы считаем только с успешных заказов
          manager.bonus = 0;
          manager.bonusOrdersCount = 0;
          orders.forEach(order => {
            if (this.successfulStatuses.includes(order.status)) {
              const bonusRaw = order.customFields && order.customFields.dfhgodsf8g7 ? order.customFields.dfhgodsf8g7 : '0';
              const bonus = parseFloat(bonusRaw.replace(',', '.'));
              if (!isNaN(bonus)) {
                manager.bonus += bonus;
                manager.bonusOrdersCount++;
              }
            }
          });
          manager.bonus = parseFloat(manager.bonus.toFixed(2));
        });
      } catch (e) {
        console.error('Ошибка при загрузке заказов:', e);
      }
    },

    renderChart() {
      const render = (id, label, sortedArray, field) => {
        const ctx = document.getElementById(id);
        if (!ctx) return;

        const labels = sortedArray.map(m => m.label);
        const data = sortedArray.map(m => m[field]);

        new Chart(ctx, {
          type: 'bar',
          data: {
            labels,
            datasets: [{
              label,
              data,
              backgroundColor: 'rgba(75, 192, 192, 0.5)'
            }]
          },
          options: {
            responsive: true,
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            },
            legend: {
              display: false
            }
          }
        });
      };
      
      const byBonus = [...this.managers].sort((a, b) => b.bonus - a.bonus);
      const byOrders = [...this.managers].sort((a, b) => b.totalOrders - a.totalOrders);
      const byCanceled = [...this.managers].sort((a, b) => b.canceledOrders - a.canceledOrders);

      const byEfficiency = [...this.managers].map(m => {
        const averageBonus = m.successfulOrders > 0 ? m.bonus / m.successfulOrders : 0;
        const conversion = m.totalOrders > 0 ? ((m.totalOrders - m.canceledOrders) / m.totalOrders) * 100 : 0;
        return {
          ...m,
          efficiency:  (conversion * 0.3) + (averageBonus * 0.2)
        };
      }).sort((a, b) => b.efficiency - a.efficiency);

      render('efficiencyChart', 'Эффективность', byEfficiency, 'efficiency');

      render('bonusChart', 'Бонус (BYN)', byBonus, 'bonus');
      render('ordersChart', 'Всего заказов', byOrders, 'totalOrders');
      render('canceledChart', 'Отмены', byCanceled, 'canceledOrders');
    },

    getManagerLabel(managerId) {
      const code = String(managerId);
      const m = this.managers.find(x => x.customFieldValue && String(x.customFieldValue) === code);
      if (m) return m.label;
      const mid = parseInt(managerId, 10);
      if (!Number.isNaN(mid)) {
        const u = this.usersSettings.find(x => parseInt(x.id, 10) === mid);
        if (u) {
          const parts = [u.firstName, u.lastName].filter(Boolean);
          if (parts.length) return parts.join(' ');
          return u.label;
        }
      }
      return `Менеджер ${managerId}`;
    },

    async fetchCallStats() {
      if (this.managers.length === 0) {
        await this.fetchManagers();
      }

      try {
        const res = await axios.get(`https://manager.1akb.by/call-stats?date=${this.callStatsDate}`);
        this.callStats = res.data;

        console.log('Сырые данные от сервера по звонкам:', this.callStats);
        // Выведите уникальные ID менеджеров, которые пришли с бэкенда:
        const uniqueManagersInResponse = [...new Set(this.callStats.map(row => row.managerId))];
        console.log('ID менеджеров в ответе API:', uniqueManagersInResponse);
        
        // Собираем все order_id из callStats
        let allOrderIds = [];
        this.callStats.forEach(row => {
          if (row.orderIds) {
            const ids = row.orderIds.split(',').map(id => id.trim()).filter(id => id && id !== 'null' && id !== '');
            allOrderIds.push(...ids);
          }
        });
        allOrderIds = Array.from(new Set(allOrderIds)); // Уникальные

        // Делаем запрос к PHP-обработчику для получения статусов заказов
        let ordersByNumber = {};
        if (allOrderIds.length > 0) {
          // retailCRM и API-обработчик поддерживают не более 100 номеров за раз
          const chunkSize = 100;
          for (let i = 0; i < allOrderIds.length; i += chunkSize) {
            const chunk = allOrderIds.slice(i, i + chunkSize);
            const params = new URLSearchParams();
            chunk.forEach(id => params.append('filter[numbers][]', id));
            const ordersRes = await axios.get(ORDERS_API_BASE + '/orders.php?' + params.toString());
            if (ordersRes.data && Array.isArray(ordersRes.data.orders)) {
              ordersRes.data.orders.forEach(order => {
                ordersByNumber[order.number] = order.status;
              });
              // Выводим все статусы заказов в консоль для анализа
              const statuses = ordersRes.data.orders.map(order => order.status);
              console.log('Статусы заказов из retailCRM:', statuses);
            }
          }
        }

        // Массив успешных статусов теперь определяется через excludedBonusStatuses
        // Вычисление общей статистики за день
        const dailyStatsMap = {};
        this.callStats.forEach(row => {
          if (this.isCallStatsRowHidden(row.managerId)) {
            return;
          }
          
          if (!dailyStatsMap[row.managerId]) {
            dailyStatsMap[row.managerId] = {
              managerId: row.managerId,
              totalCalls: 0,
              totalIncoming: 0,
              totalOutgoing: 0,
              totalDuration: 0,
              totalIncomingDuration: 0,
              totalOutgoingDuration: 0,
              newCallsAnswered: 0,
              // Новые поля для заказов по звонкам
              totalOrdersByCalls: 0,
              canceledOrdersByCalls: 0,
              successfulOrdersByCalls: 0,
            };
          }
          dailyStatsMap[row.managerId].totalCalls += row.callCount || 0;
          dailyStatsMap[row.managerId].totalIncoming += row.incomingCallCount || 0;
          dailyStatsMap[row.managerId].totalOutgoing += row.outgoingCallCount || 0;
          dailyStatsMap[row.managerId].totalDuration += row.totalDuration || 0;
          dailyStatsMap[row.managerId].totalIncomingDuration += row.incomingDuration || 0;
          dailyStatsMap[row.managerId].totalOutgoingDuration += row.outgoingDuration || 0;
          dailyStatsMap[row.managerId].newCallsAnswered += row.newCallsAnswered || 0;
          // Считаем заказы по звонкам
          if (row.orderIds) {
            const ids = row.orderIds.split(',').map(id => id.trim()).filter(id => id && id !== 'null' && id !== '');
            ids.forEach(orderId => {
              const status = ordersByNumber[orderId];
              dailyStatsMap[row.managerId].totalOrdersByCalls++;
              if (status && this.cancellationStatuses.includes(status)) {
                dailyStatsMap[row.managerId].canceledOrdersByCalls++;
              } else if (status && this.successfulStatuses.includes(status)) {
                dailyStatsMap[row.managerId].successfulOrdersByCalls++;
              }
              // остальные статусы не считаются ни успешными, ни отменёнными
            });
          }
        });
        this.dailyCallStats = Object.values(dailyStatsMap);
        // Рассчитываем конверсию по заказам
        this.dailyCallStats.forEach(stats => {
          const conversionRate = stats.totalOrdersByCalls > 0 ?
            ((stats.successfulOrdersByCalls / stats.totalOrdersByCalls) * 100).toFixed(1) : 0;
          stats.conversionRate = conversionRate;
        });

        this.$nextTick(() => this.renderCallsChart());
      } catch (e) {
        this.callStats = [];
        this.dailyCallStats = [];
        console.error('Ошибка при загрузке статистики звонков:', e);
      }
    },

    selectManager(managerId) {
      this.selectedManagerId = managerId;
      this.selectedManagerCallStats = this.callStats.filter(row => row.managerId === managerId);
      this.$nextTick(() => {
        this.renderCallsChart();
      });
    },

    clearManagerSelection() {
      this.selectedManagerId = null;
      this.selectedManagerCallStats = [];
      this.$nextTick(() => {
        this.renderCallsChart();
      });
    },

    sortCallStats(key) {
      if (this.callStatsSortKey === key) {
        this.callStatsSortDesc = !this.callStatsSortDesc;
      } else {
        this.callStatsSortKey = key;
        this.callStatsSortDesc = true;
      }
    },

    formatDuration(seconds) {
      // Преобразуем в число и проверяем
      const numSeconds = parseInt(seconds) || 0;
      
      if (numSeconds === 0) return '0с';
      
      const hours = Math.floor(numSeconds / 3600);
      const minutes = Math.floor((numSeconds % 3600) / 60);
      const secs = numSeconds % 60;
      
      if (hours > 0) {
        return `${hours}ч ${minutes}м ${secs}с`;
      } else if (minutes > 0) {
        return `${minutes}м ${secs}с`;
      } else {
        return `${secs}с`;
      }
    },

    renderCallsChart() {
      if (this.callsChart) {
        this.callsChart.destroy();
      }
      if (!this.callStats.length) return;
      
      // Если выбран конкретный менеджер, показываем только его данные
      const dataToShow = this.selectedManagerId 
        ? this.callStats.filter(row => row.managerId === this.selectedManagerId)
        : this.callStats;
      
      const labels = [...new Set(dataToShow.map(r => r.hour))].sort((a, b) => a - b);
      
      const datasets = [];
      
      if (this.selectedManagerId) {
        // График для одного менеджера
        const managerLabel = this.getManagerLabel(this.selectedManagerId);
        datasets.push({
          label: 'Входящие звонки',
          data: labels.map(hour => {
            const row = dataToShow.find(r => r.hour === hour);
            return row ? row.incomingCallCount : 0;
          }),
          backgroundColor: 'rgba(75, 192, 192, 0.7)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 2,
        });
        datasets.push({
          label: 'Исходящие звонки',
          data: labels.map(hour => {
            const row = dataToShow.find(r => r.hour === hour);
            return row ? row.outgoingCallCount : 0;
          }),
          backgroundColor: 'rgba(255, 99, 132, 0.7)',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 2,
        });
      } else {
        // График для всех менеджеров
        const grouped = {};
        dataToShow.forEach(row => {
          if (!grouped[row.managerId]) {
            grouped[row.managerId] = { hours: [], counts: [] };
          }
          grouped[row.managerId].hours.push(row.hour);
          grouped[row.managerId].counts.push(row.callCount);
        });

        // Расширенная палитра цветов
        const colors = [
          'rgba(54, 162, 235, 0.7)',   // Синий
          'rgba(255, 99, 132, 0.7)',   // Красный
          'rgba(75, 192, 192, 0.7)',   // Бирюзовый
          'rgba(255, 206, 86, 0.7)',   // Желтый
          'rgba(153, 102, 255, 0.7)',  // Фиолетовый
          'rgba(255, 159, 64, 0.7)',   // Оранжевый
          'rgba(199, 199, 199, 0.7)',  // Серый
          'rgba(83, 102, 255, 0.7)',   // Индиго
          'rgba(255, 99, 255, 0.7)',   // Пурпурный
          'rgba(99, 255, 132, 0.7)',   // Зеленый
          'rgba(255, 159, 199, 0.7)',  // Розовый
          'rgba(159, 255, 64, 0.7)',   // Лайм
          'rgba(64, 159, 255, 0.7)',   // Голубой
          'rgba(255, 64, 159, 0.7)',   // Малиновый
          'rgba(159, 64, 255, 0.7)',   // Темно-фиолетовый
          'rgba(64, 255, 159, 0.7)',   // Морская волна
        ];

        // Функция для генерации уникального цвета если закончились предустановленные
        const generateColor = (index) => {
          if (index < colors.length) {
            return colors[index];
          }
          // Генерируем цвет на основе индекса
          const hue = (index * 137.508) % 360; // Золотое сечение для равномерного распределения
          return `hsla(${hue}, 70%, 60%, 0.7)`;
        };

        Object.keys(grouped).forEach((managerId, index) => {
          const managerLabel = this.getManagerLabel(managerId);
          const backgroundColor = generateColor(index);
          const borderColor = backgroundColor.replace('0.7', '1').replace('hsla', 'hsl');
          
          datasets.push({
            label: managerLabel,
            data: labels.map(hour => grouped[managerId].counts[grouped[managerId].hours.indexOf(hour)] || 0),
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            borderWidth: 2,
            fill: false, // Убираем заливку для лучшей читаемости
          });
        });
      }

      const ctx = document.getElementById('callsChart');
      if (!ctx) return;
      this.callsChart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: labels.map(h => `${h}:00`),
          datasets
        },
        options: {
          responsive: true,
          scales: {
            yAxes: [{
              ticks: { beginAtZero: true }
            }]
          },
          legend: { display: true }
        }
      });
    },

    // Метод для определения успешного заказа по его ID
    isSuccessfulOrder(orderId) {
      if (!orderId || orderId === 'null' || orderId === '') return false;
      
      // Проверяем, что заказ НЕ находится в списке статусов отмены/проблем
      // Используем ту же логику что и для подсчета бонусов
      return !this.excludedBonusStatuses.some(status => orderId.includes(status));
    },

    // Подсчет эффективных звонков по order_id из строки
    countEffectiveCallsFromOrderIds(orderIdsString) {
      if (!orderIdsString) return 0;
      
      // Разбиваем строку и фильтруем пустые/null значения
      const orderIds = orderIdsString.split(',').filter(id => id && id !== 'null' && id.trim() !== '');
      
      // Считаем только успешные заказы
      const effectiveCount = orderIds.filter(orderId => this.isSuccessfulOrder(orderId)).length;
      
      // Отладка
      if (orderIdsString.includes(',') || orderIds.length > 0) {
        console.log(`  countEffective: входная строка="${orderIdsString}", заказов=${orderIds.length}, эффективных=${effectiveCount}, заказы=[${orderIds.join(', ')}]`);
      }
      
      return effectiveCount;
    },

    getWeekdayShort(dateStr) {
      if (!dateStr) return '';
      const days = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
      const d = new Date(dateStr);
      if (isNaN(d)) return '';
      return days[d.getDay()];
    },


  },
  mounted() {
    this.fetchManagers();
  },
  watch: {
    activeTab(newTab) {
      if (newTab === 'calls') {
        this.fetchCallStats();
      }
    },
    callStatsDate(newDate) {
      this.fetchCallStats();
    }
  }
};
</script>

<style scoped>
/* Базовые стили как в OrderEdit */
.order-form-wrapper {
  font-family: 'Segoe UI', sans-serif;
  background: #f8f9fb;
  width: 100%;
}

.order-head {
  padding: 32px 0 24px;
}

.order-head__flex {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
}

.order-head > div {
  color: #1e2248;
  font-size: 12px;
  width: 100%;
}

.order-num {
  font-size: 24px;
  font-weight: 500;
  color: #1e2248;
}

.s-and-a {
  font-size: 12px;
  line-height: 14px;
  margin: 0 0 0 24px;
}

.s-and-a__discr {
  color: #636f7f !important;
  font-style: normal !important;
}

.s-and-a .value {
  font-weight: 600;
  color: #1e2248;
  font-size: 14px;
  line-height: 20px;
}

/* Табы */
.tabs {
  display: flex;
  gap: 10px;
}

.tabs button {
  padding: 12px 24px;
  border: none;
  background: #e9ecef;
  cursor: pointer;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #636f7f;
  transition: all 0.3s ease;
}

.tabs button.active {
  background: #0078d7;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 120, 215, 0.3);
}

.tabs button:hover:not(.active) {
  background: #dee2e6;
  color: #1e2248;
}

/* Основной контейнер */
.m-box {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-top: 24px;
}

.inside {
  padding: 32px;
}

/* Современная таблица */
.modern-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.modern-table thead {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}

.modern-table th {
  padding: 16px 20px;
  font-weight: 600;
  font-size: 14px;
  text-align: left;
  border: none;
}

.modern-table th.sortable {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.modern-table th.sortable:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.modern-table td {
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
  font-size: 14px;
  color: #1e2248;
}

.modern-table tr:hover {
  background-color: #f8f9fa;
}

.modern-table tr:last-child td {
  border-bottom: none;
}

/* Специальные стили для ячеек */
.manager-name {
  font-weight: 600;
  color: #1e2248;
}

.number-cell {
  text-align: right;
  font-family: 'Segoe UI', monospace;
  font-weight: 500;
}

.medal {
  margin-right: 8px;
  font-size: 16px;
}

.efficiency {
  color: #28a745;
  font-weight: 600;
}

/* Секция графиков */
.charts-section {
  margin-top: 48px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 32px;
}

.chart-container {
  background: #f8f9fa;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #e9ecef;
  margin-top: 30px;
}

.chart-container h3 {
  margin: 0 0 16px 0;
  color: #1e2248;
  font-size: 18px;
  font-weight: 600;
}

/* Фильтр по дате */
.date-filter {
  margin-bottom: 32px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.date-input {
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
  min-width: 150px;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-primary {
  background: #0078d7;
  color: #fff;
}

.btn-primary:hover {
  background: #106ebe;
  transform: translateY(-1px);
}

.btn.small {
  padding: 6px 12px;
  font-size: 13px;
}

/* Фильтр даты */
.date-filter {
  margin-bottom: 24px;
  padding: 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.date-filter .s-and-a {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 0;
  float: none;
}

.date-filter .s-and-a__discr {
  white-space: nowrap;
  min-width: auto;
}

/* Секции статистики */
.stats-section {
  margin-bottom: 32px;
}

.section-title {
  margin: 0 0 24px 0;
  color: #1e2248;
  font-size: 20px;
  font-weight: 600;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 12px;
}

/* Сетка карточек статистики */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.stats-card {
  background: #fff;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.stats-card:hover {
  border-color: #0078d7;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 120, 215, 0.15);
}

.stats-card.active {
  border-color: #0078d7;
  background: linear-gradient(135deg, #f8fbff 0%, #e6f3ff 100%);
  box-shadow: 0 4px 16px rgba(0, 120, 215, 0.2);
}

.stats-card-header h4 {
  margin: 0 0 16px 0;
  color: #1e2248;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 8px;
}

.stats-card-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}

.stat-label {
  color: #636f7f;
  font-size: 13px;
}

.stat-value {
  font-weight: 600;
  font-size: 14px;
  color: #1e2248;
}

.stat-value.incoming {
  color: #28a745;
}

.stat-value.outgoing {
  color: #dc3545;
}

.stat-value.time {
  color: #6f42c1;
}

/* Детальная таблица */
.details-section {
  margin-top: 32px;
  padding-top: 32px;
  border-top: 2px solid #e9ecef;
}

.details-table {
  font-size: 13px;
}

.hour-cell {
  font-weight: 600;
  color: #0078d7;
}

.number-cell.incoming {
  color: #28a745;
}

.number-cell.outgoing {
  color: #dc3545;
}

.number-cell.time {
  color: #6f42c1;
}

.number-cell.answered {
  color: #fd7e14;
  font-weight: 600;
}

/* Сообщение об отсутствии данных */
.no-data {
  text-align: center;
  padding: 48px 24px;
  color: #636f7f;
  font-size: 16px;
}

.no-data p {
  margin: 0;
  font-size: 18px;
}

/* Утилитарные классы */
.ft-lt {
  float: left;
}

.cleared::after {
  content: "";
  display: table;
  clear: both;
}

.gray {
  color: #636f7f;
}

.italic {
  font-style: italic;
}

.red {
  color: #dc3545;
}

.dib {
  display: inline-block;
}

.align-middle {
  vertical-align: middle;
}

/* Новые стили для улучшенной статистики */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.btn-secondary {
  background: #6c757d;
  color: #fff;
}

.btn-secondary:hover {
  background: #5a6268;
  transform: translateY(-1px);
}

.table-wrapper {
  overflow-x: auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.stats-table {
  margin: 0;
}

.stats-table th {
  background: linear-gradient(135deg, #f8fbff 0%, #e6f3ff 100%);
  position: sticky;
  top: 0;
  z-index: 10;
}

.manager-row.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
}

.manager-row.clickable:hover {
  background: #f8f9fa;
  transform: translateX(2px);
}

.manager-row.active {
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  box-shadow: inset 3px 0 0 #ffc107;
}

.manager-row.top-performer {
  background: linear-gradient(135deg, #f8fff8 0%, #e8f5e8 100%);
}

.manager-row.top-performer:hover {
  background: linear-gradient(135deg, #e8f5e8 0%, #d4edda 100%);
}

.number-cell.efficiency {
  font-weight: 600;
  color: #0078d7;
}

.number-cell.effective {
  font-weight: 600;
  color: #10b981;
}

.number-cell.conversion {
  font-weight: 600;
  color: #f59e0b;
}

.number-cell.bonus {
  font-weight: 600;
  color: #8b5cf6;
}

.number-cell.avg-bonus {
  font-weight: 600;
  color: #6366f1;
}

.number-cell.effective-time {
  font-weight: 600;
  color: #059669;
}

/* Аналитические карточки */
.analytics-section {
  margin-top: 48px;
  padding-top: 32px;
  border-top: 2px solid #e9ecef;
}

.analytics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

.analytics-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.analytics-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.analytics-card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  padding: 16px 20px;
}

.analytics-card-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.analytics-card-content {
  padding: 20px;
}

.top-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f1f3f4;
}

.top-item:last-child {
  border-bottom: none;
}

.top-item .rank {
  width: 24px;
  font-weight: 600;
  color: #0078d7;
}

.top-item .name {
  flex: 1;
  margin-left: 12px;
  color: #1e2248;
}

.top-item .value {
  font-weight: 600;
  color: #28a745;
}

.metric-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f1f3f4;
}

.metric-item:last-child {
  border-bottom: none;
}

.metric-label {
  color: #636f7f;
  font-size: 14px;
}

.metric-value {
  font-weight: 600;
  color: #1e2248;
  font-size: 14px;
}

/* Адаптивность */
@media (max-width: 768px) {
  .order-head__flex {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .analytics-grid {
    grid-template-columns: 1fr;
  }
  
  .table-wrapper {
    font-size: 12px;
  }
}

.blur-bonus {
  filter: blur(7px);
  transition: filter 0.2s;
  cursor: pointer;
  position: relative;
}
.blur-bonus:hover {
  filter: none;
}
</style>